// Removed Ant Design imports
import { API } from 'aws-amplify';
import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  EmailIcon,
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton
} from 'react-share';
import { useLocalization } from '../../../localization';
import { useGlobalState } from '../../../store';
// Added CBButton, CBModal imports
import { CBButton, CBCheckItem, CBModal } from '../components/cbd'; // Assuming CBCheckItem is in cbd
import SEO from '../../SEO'; // Corrected path
import WebContainer from '../../webcontainer'; // Corrected path

import createShareButton from 'react-share/es/hocs/createShareButton';
import objectToGetParams from 'react-share/es/utils/objectToGetParams';

// Removed Title import

function emailLink(url, _a) {
  var subject = _a.subject,
    body = _a.body,
    separator = _a.separator;
  return (
    'mailto:' +
    objectToGetParams({
      subject: subject,
      body: body ? body + separator + url : url,
    })
  );
}

var EmailBlankTargetShareButton = createShareButton(
  'email', emailLink,
  function (props) { return { subject: props.subject, body: props.body, separator: props.separator || ' ' }; },
  { openShareDialogOnClick: false, onClick: function (_, link) { window.open(link, '_blank'); } }
);

const CALENDARBRIDGE_URL = 'https://www.calendarbridge.com';

const ReferralList = () => {
  const { t } = useLocalization();
  const [events, setEvents] = useState([]);
  const [license, setLicense] = useGlobalState('license'); // License needed here? Maybe not.
  useEffect(() => {
    async function load() {
      try { // Added try-catch
        var refs = await API.get('billing', '/billing?referrals=true');
        setEvents(refs.referrals || []); // Ensure refs.referrals is an array
      } catch (error) {
        console.error("Failed to load referrals:", error);
        // Optionally show an error message to the user
      }
    }
    load();
  }, []);

  const list = events.map((event) => (
    <div key={event.redeemerEmail} className="p-2 text-gray-600 text-sm"> {/* Use Tailwind */}
      {event.redeemerEmail} -{' '}
      {event.awarded == 'awarded' ? (
        <b className="text-green-600">{t('referral.status_awarded')}</b>
      ) : (
        <>
          <b className="text-red-600">{event.awarded}</b> -{' '}
          <b>{moment(event.started * 1000).format('L')}</b>
        </>
      )}
    </div>
  ));

  return (
    <div className="my-3 mt-10 mb-10"> {/* Use Tailwind */}
      <p className="text-gray-600 mb-2">{t('referral.referrals_list_title')}</p>
      {list.length > 0 ? list : <p className="text-gray-500 text-sm">No referrals yet.</p>} {/* Handle empty list */}
    </div>
  );
};

const ShareList = ({ code }) => {
  const { t } = useLocalization();
  const codeShare = code;
  const buttonRadius = 40;
  const shareUrl = `${CALENDARBRIDGE_URL}/share/${codeShare}`;
  const shareTitle = t('referral.share_title');
  const shareSummary = t('referral.share_summary', { code: codeShare });
  const shareBody = t('referral.share_email_body', { code: codeShare, url: shareUrl });

  return (
    <div className="mb-2 mt-3 flex justify-center space-x-3"> {/* Use flex and spacing */}
      <LinkedinShareButton url={shareUrl} title={shareTitle} summary={shareSummary}>
        <LinkedinIcon size={buttonRadius} round={true} />
      </LinkedinShareButton>
      <FacebookShareButton url={shareUrl} quote={shareSummary}>
        <FacebookIcon size={buttonRadius} round={true} />
      </FacebookShareButton>
      <TwitterShareButton url={shareUrl} title={shareSummary} hashtags={['calendarbridge', 'calendarsync']}>
        <TwitterIcon size={buttonRadius} round={true} />
      </TwitterShareButton>
      <EmailBlankTargetShareButton url={shareUrl} subject={shareTitle} body={shareBody}>
        <EmailIcon size={buttonRadius} round={true} />
      </EmailBlankTargetShareButton>
    </div>
  );
};

const ReferralPage = () => {
  const { t } = useLocalization();
  const [license, setLicense] = useGlobalState('license');
  const [isProcessing, setIsProcessing] = useState(false);
  const [termsAccepted, setTermsAccepted] = useState(false);
  const [visible, setVisible] = useState(false); // For terms modal

  async function optIn(option) {
    setIsProcessing(true);
    try {
      var opt = await API.post('billing', '/billing?optIn=' + option, { body: {} });
      setLicense(opt.license);
    } catch (ex) {
        console.error("Opt-in failed:", ex);
        alert("Failed to update referral preference."); // User feedback
    } finally { // Ensure loading state is reset
        setIsProcessing(false);
    }
  }

  function showModal(e) {
    e.preventDefault();
    setVisible(true);
  }

  function handleOk() { // Close modal
    setVisible(false);
  }

  function handleCancel() { // Close modal
    setVisible(false);
  }

  return (
    <>
      <SEO title={t('referral.page_title')} />
      {/* Removed WebContainer, assuming it's part of a higher-level layout */}
      <div className="cb-content-frame">
        <div className="cb-content-pane font-sarabun text-neutral_4 mobile_padding min-h-screen">
          {/* Replaced Row/Col with div and Tailwind */}
          <div className="mx-2 md:mx-auto max-w-3xl"> {/* Centering and max-width */}
            <div className="w-full">
              {/* Replaced Title with h1 */}
              <h1 className="text-center text-3xl font-semibold mb-6">{t('referral.page_title')}</h1>
              {license && (license.trial || license.code == 'site') && (
                <h2 className="text-center text-xl text-red-600 mb-6">
                  {t('referral.paid_only_message')}
                </h2>
              )}
              {license && license.code != 'site' && license.referralCode && ( // Check referralCode exists
                <div className="text-center mb-24"> {/* Increased margin */}
                  {/* Replaced Title with h3 */}
                  <h3 className="text-xl md:text-2xl leading-relaxed mb-5">
                    {t('referral.share_code_title')}
                  </h3>
                  <div className="text-md mb-4 mt-4">
                    <a href="#" onClick={showModal} className="text-blue-600 hover:underline">
                      {t('referral.view_terms_link')}
                    </a>
                  </div>
                  {/* Replaced Title with h3 and span */}
                  <h3 className="inline text-xl md:text-2xl">{t('referral.your_code_label')} </h3>{' '}
                  <span className="text-xl md:text-2xl font-semibold bg-gray-100 px-2 py-1 rounded">
                    {license.referralCode}
                    {/* Add copy functionality if needed */}
                  </span>
                  <ShareList code={license.referralCode} />
                  <p className="text-md md:text-lg leading-relaxed mt-6 text-gray-600">
                    {t('referral.program_description')}
                  </p>
                  <ReferralList />
                  <CBButton
                    loading={isProcessing}
                    disabled={isProcessing}
                    onClick={(e) => optIn(false)}
                    type="default" // Use default style for opt-out
                  >
                    {t('referral.opt_out_button')}
                  </CBButton>
                </div>
              )}

              {license && license.code != 'site' && !license.referralCode && ( // Check referralCode is empty
                <>
                  <p className="text-md md:text-lg leading-relaxed text-gray-600 mb-4">
                    {t('referral.opt_in_intro')}
                  </p>
                  <h2 className="text-center text-2xl font-semibold mb-4">
                    {t('referral.give_get_month_title')}
                  </h2>
                  <p className="text-md md:text-lg leading-relaxed text-gray-600 mb-6">
                    {t('referral.opt_in_description')}
                  </p>
                  <div className="text-center">
                    <CBButton
                      loading={isProcessing}
                      disabled={!termsAccepted || isProcessing} // Disable if terms not accepted
                      onClick={(e) => optIn(true)}
                      type="primary"
                      className="w-56" // Set fixed width
                    >
                      {t('referral.sign_me_up_button')}
                    </CBButton>
                  </div>
                  <div className="text-center mb-24 mt-4"> {/* Increased margin */}
                    <CBCheckItem
                      onChange={setTermsAccepted} // Pass setter directly
                      checked={termsAccepted}
                      label={t('referral.accept_terms_prefix')}
                      // color="#B85614" // CBCheckItem might not support color
                      className="inline-block mr-1" // Adjust layout
                    />
                    <a href="#" onClick={showModal} className="text-blue-600 hover:underline text-sm">
                      {t('referral.view_terms_link')}
                    </a>
                  </div>
                </>
              )}
            </div>
          </div>
          {/* Replaced Modal with CBModal */}
          <CBModal
            title={t('referral.modal_title')}
            visible={visible}
            onOk={handleOk} // Use onOk for primary action (close)
            onCancelClick={handleCancel} // Use onCancelClick for closing via 'x' or background
            // Footer customization: Only show a close button
            hideFooter={true} // Hide default footer
          >
             <div className="prose prose-sm max-h-[60vh] overflow-y-auto pr-4"> {/* Add prose for styling and scroll */}
                <ol className="list-decimal pl-5 space-y-2">
                  <li>{t('referral.terms.item1')}</li>
                  <li>{t('referral.terms.item2')}</li>
                  <li>{t('referral.terms.item3')}</li>
                  <li>{t('referral.terms.item4')}</li>
                  <li>{t('referral.terms.item5')}</li>
                  <li>{t('referral.terms.item6')}</li>
                  <li>{t('referral.terms.item7')}</li>
                  <li>{t('referral.terms.item8')}</li>
                  <li>{t('referral.terms.item9')}</li>
                  <li>{t('referral.terms.item10')}</li>
                  <li>{t('referral.terms.item11')}</li>
                  <li>{t('referral.terms.item12')}</li>
                  <li>{t('referral.terms.item13')}</li>
                  <li>{t('referral.terms.item14')}</li>
                  <li>{t('referral.terms.item15')}</li>
                  <li>{t('referral.terms.item16')}</li>
                  <li>
                    {t('referral.terms.item17_prefix')}{' '}
                    <a href="https://calendarbridge.com/terms-and-privacy" target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                      {t('referral.terms.item17_link')}
                    </a>
                  </li>
                </ol>
             </div>
             {/* Custom Footer */}
             <div className="flex justify-end mt-4 pt-4 border-t">
                 <CBButton key="submit" type="primary" onClick={handleOk}>
                   {t('common.close_button')}
                 </CBButton>
             </div>
          </CBModal>
        </div>
      </div>
    </>
  );
};

export default ReferralPage;
